<template>
  <v-card>
    <div class="pt-2 pb-0 pa-2">
      <div
        v-if="combinedSheets.length === 0"
        class="text-caption mb-2"
        style="color: rgb(var(--v-theme-on-surface-variant));"
      >
        対象なし
      </div>
      <router-link
        v-for="sheet in combinedSheets"
        :key="sheet.id"
        :to="sheetRoute(sheet.id)"
        class="d-block"
        style="text-decoration: none;"
      >
        <daytime-advice-assigned-sheet-card
          :sheet="sheet"
          :active="isActiveSheet(sheet.id)"
        />
      </router-link>
    </div>
  </v-card>
</template>

<script>
import DaytimeAdviceAssignedSheetCard from "./DaytimeAdviceAssignedSheetCard.vue";

export default {
  name: "DaytimeAdviceAssignedSheetList",
  components: {
    DaytimeAdviceAssignedSheetCard
  },
  props: {
    attentionSheets: {
      type: Array,
      default: () => []
    },
    nonAttentionSheets: {
      type: Array,
      default: () => []
    },
    activeSheetId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    combinedSheets: function() {
      return [...this.attentionSheets, ...this.nonAttentionSheets];
    }
  },
  methods: {
    sheetRoute: function(sheetId) {
      return { name: "daytimeAdviceSheet", params: { id: sheetId } };
    },
    isActiveSheet: function(sheetId) {
      if (this.activeSheetId == null) return false;

      return String(this.activeSheetId) == String(sheetId);
    }
  }
};
</script>
